<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <div v-else>
    <v-col cols="12" class="pa-3">
      <v-row>
        <v-col cols="12" md="9" class="pt-2">
          <v-card
            class="EK-card rounded-xl border-top border-right rounded-tr-0 EK-shadow IMTOrange"
          >
            <v-data-table
              dense
              :headers="headers"
              :items="usersList"
              hide-default-footer
              :search="searchText"
              :items-per-page="10"
              :page.sync="page"
              @page-count="pageCount = $event"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="searchText"
                  color="IMThemeGray"
                  style="width: 280px"
                  label="بحث في الجدول"
                  append-icon="mdi-magnify"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item, index }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <tr 
                        v-on="on" v-bind="attrs"
                        @click="goToDetails(usersList.findIndex(user => user.id == item.id))" :class="{ active: id == (page-1)*10+index }">
                          <td>
                            {{ item.fullName == null ? "لا يوجد" : item.fullName }}
                          </td>
                          <td dir="ltr">{{ item.username }}</td>
                          <td>
                            <span v-for="role in item.roles" :key="role"> {{ role }}, </span>
                          </td>
                          <td>
                            <v-btn @click="SubmitRemoveUser(item)" text>
                              <img src="/media/svg/table/delete.svg" alt="delete" />
                            </v-btn>
                          </td>
                        </tr>
                    </template>
                    <span>انقر لعرض التفاصيل</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <div class="w-100 pb-10 mt-10">
     
              <a-pagination 
              
             
             
              v-model="page"
              :showTotal="(total) => `من أصل ${total} عنصر`"
              pageSize="10"

              :total="usersList.length"
              @showSizeChange="page"
              
              size="large" show-size-changer show-quick-jumper />
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<style lang="scss" scoped>
.active {
  background: rgba(0, 0, 0, 0.125) !important;
}
</style>
<style lang="scss">
td {
  text-align: center;
}
</style>
<script>

import loading from "@/components/loading";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import aPagination from  'ant-design-vue/lib/pagination'

export default {
  components: {
    loading,
    aPagination,
  },
  props: {
    id: String,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    searchText: "",
    headers: [
      {
        text: "الاسم والكنية",
        sortable: true,
        value: "fullName",
      },
      { text: "اسم المستخدم", value: "username",sortable: true, },
      { text: "نوع الحساب", value: "roles",sortable: true, },
      {
        text: "حذف",
        value: "delete",
        sortable: false,
      },
    ],
  }),
  methods: {
    ...mapActions(["fetchUsers", "setBreadcrumbs", "removeUser"]),
    goToDetails(index) {
      if (index != this.id) {
        this.$router.push("./" + index);
      }
    },
    SubmitRemoveUser(userItem) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: "هل أنت متأكد؟",
          text: "هل فعلاً تريد حذف المستخدم ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "نعم!",
          cancelButtonText: "إلغاء",
          reverseButtons: false,
        })
        .then((result) => {
          if (result.value) {
            this.removeUser(userItem);
            if (this.id != -1) {
              this.$router.push("./-1");
            }
          }
        });
    },
  },
  computed: {
    ...mapGetters(["usersList", "isLoading"]),
  },
  created() {
    this.fetchUsers();
    this.setBreadcrumbs([
      {
        text: "الإعدادت",
        disabled: false,
      },
      {
        text: "الحسابات",
        disabled: false,
      },
    ]);
  },
};
</script>
